/** Backend CustomPermissionFunctionality values. Preserve unknown grants when editing roles. */
export const CUSTOM_FUNCTIONALITIES = {
  TENANT_NO_RS_GLOBAL: 'tenant_no_rs_global',
  DW_SEARCH_SPACE: 'dw_search_space',
  DW_AGGR_SPACE: 'dw_aggr_space',
  DW_AGGR_REVENUE_TS: 'dw_aggr_revenue_ts',
  DW_SEARCH_GENERAL_ERRAND: 'dw_search_general_errand',
  DW_AGGR_GENERAL_ERRAND: 'dw_aggr_general_errand',
  DW_AGGR_INVOICE: 'dw_aggr_invoice',
  DW_SEARCH_INVOICE: 'dw_search_invoice',
  DW_AGGR_CONTRACT: 'dw_aggr_contract',
  DW_AGGR_LISTING: 'dw_aggr_listing',
} as const;

export type CustomFunctionality =
  (typeof CUSTOM_FUNCTIONALITIES)[keyof typeof CUSTOM_FUNCTIONALITIES];
